// Lightweight i18n — a single Bulgarian dictionary. Keep keys hierarchical
// (dot-delimited) to group logically. Missing keys fall back to the key itself.

const dict = {
  // ---- App / brand ----
  'app.name': 'Smart Key Sofia',
  'app.tagline': 'Управление на ключове, пратки и продажби',

  // ---- Navigation ----
  'nav.dashboard': 'Табло',
  'nav.inventory': 'Наличност',
  'nav.shipments': 'Пратки',
  'nav.sales': 'Продажби',
  'nav.partners': 'Партньори',
  'nav.suppliers': 'Доставчици',
  'nav.tools': 'Инструменти',
  'nav.reports': 'Справки',
  'nav.settings': 'Настройки',
  'nav.logout': 'Изход',

  // ---- Common actions ----
  'action.save': 'Запази',
  'action.cancel': 'Откажи',
  'action.delete': 'Изтрий',
  'action.edit': 'Редактирай',
  'action.add': 'Добави',
  'action.create': 'Създай',
  'action.search': 'Търси',
  'action.filter': 'Филтрирай',
  'action.export': 'Експорт',
  'action.print': 'Печат',
  'action.close': 'Затвори',
  'action.confirm': 'Потвърди',
  'action.back': 'Назад',
  'action.view': 'Виж',
  'action.reset': 'Изчисти',
  'action.apply': 'Приложи',
  'action.refresh': 'Опресни',
  'action.reload': 'Презареди',
  'action.loading': 'Зареждане…',
  'action.saving': 'Запазване…',

  // ---- Key statuses ----
  'keyStatus.available': 'налично',
  'keyStatus.reserved': 'резервирано',
  'keyStatus.sold': 'продадено',
  'keyStatus.defective': 'дефектно',

  // ---- Shipment statuses ----
  'shipmentStatus.in_transit': 'в транзит',
  'shipmentStatus.arrived': 'пристигнало',
  'shipmentStatus.distributed': 'разпределено',

  // ---- Conditions ----
  'condition.new_oem': 'ново OEM',
  'condition.used_oem': 'употребявано OEM',
  'condition.aftermarket': 'афтърмаркет',

  // ---- Partner types ----
  'partnerType.importer': 'вносител',
  'partnerType.shop': 'магазин',
  'partnerType.individual': 'физическо лице',

  // ---- Allocation ----
  'allocation.equal': 'поравно',
  'allocation.weighted': 'пропорционално',

  // ---- Job types ----
  'jobType.AKL': 'AKL (всички ключове загубени)',
  'jobType.add_key': 'Добавяне на ключ',
  'jobType.replacement': 'Замяна',
  'jobType.unlock': 'Отключване',

  // ---- Roles ----
  'role.admin': 'администратор',
  'role.viewer': 'преглед',

  // ---- Login ----
  'login.title': 'Влизане в системата',
  'login.subtitle': 'Въведете Вашите данни за достъп',
  'login.email': 'Електронна поща',
  'login.password': 'Парола',
  'login.submit': 'Вход',
  'login.error': 'Невалидни данни за вход',
  'login.forgot': 'Забравена парола?',

  // ---- Dashboard ----
  'dashboard.title': 'Табло',
  'dashboard.inventoryValue': 'Стойност наличност',
  'dashboard.inventoryCount': 'Брой ключове в наличност',
  'dashboard.profitMonth': 'Печалба този месец',
  'dashboard.profitYtd': 'Печалба от началото на годината',
  'dashboard.avgDaysToSell': 'Средно дни до продажба',
  'dashboard.profitByMonth': 'Печалба по месец',
  'dashboard.profitByBrand': 'Печалба по марка',
  'dashboard.slowestMoving': 'Най-бавно движещи се',
  'dashboard.recentSales': 'Последни продажби',
  'dashboard.days': 'дни',

  // ---- Inventory ----
  'inventory.title': 'Наличност',
  'inventory.subtitle': 'Списък на всички ключове в системата',
  'inventory.add': 'Добави ключ',
  'inventory.search': 'Търси по марка, модел, тип, FCC ID…',
  'inventory.filterBrand': 'Марка',
  'inventory.filterStatus': 'Статус',
  'inventory.filterShipment': 'Пратка',
  'inventory.filterCondition': 'Състояние',
  'inventory.filterDateFrom': 'От дата',
  'inventory.filterDateTo': 'До дата',
  'inventory.selected': 'избрани',
  'inventory.bulkChangeStatus': 'Промени статус',
  'inventory.noResults': 'Няма намерени ключове',
  'inventory.emptyDesc': 'Добавете първия ключ към наличността',

  // ---- Key columns ----
  'key.brand': 'Марка',
  'key.model': 'Модел',
  'key.yearRange': 'Години',
  'key.yearFrom': 'Година от',
  'key.yearTo': 'Година до',
  'key.keyType': 'Тип ключ',
  'key.buttons': 'Бутони',
  'key.fccId': 'FCC ID',
  'key.partNumber': 'Каталожен №',
  'key.condition': 'Състояние',
  'key.status': 'Статус',
  'key.supplyPriceUsd': 'Доставна цена (USD)',
  'key.allocatedShipping': 'Разпределена доставка',
  'key.allocatedFees': 'Разпределени такси',
  'key.totalCost': 'Обща себестойност',
  'key.receivedDate': 'Дата на получаване',
  'key.notes': 'Бележки',
  'key.shipment': 'Пратка',
  'key.created': 'Създадено',
  'key.id': 'ID',

  // ---- Key form ----
  'keyForm.newTitle': 'Нов ключ',
  'keyForm.editTitle': 'Редактиране на ключ',
  'keyForm.sectionBasic': 'Основна информация',
  'keyForm.sectionCost': 'Себестойност',
  'keyForm.sectionDetails': 'Детайли',
  'keyForm.liveCost': 'Изчислена себестойност',
  'keyForm.costFormula': 'USD × курс + разпределена доставка + разпределени такси',
  'keyForm.pickShipment': 'Изберете пратка',
  'keyForm.noShipment': 'Без пратка',
  'keyForm.created': 'Ключът е създаден',
  'keyForm.updated': 'Ключът е обновен',
  'keyForm.deleted': 'Ключът е изтрит',

  // ---- Key detail ----
  'keyDetail.title': 'Ключ',
  'keyDetail.tabInfo': 'Основна информация',
  'keyDetail.tabCosts': 'Разходи',
  'keyDetail.tabHistory': 'История',
  'keyDetail.tabSale': 'Продажба',
  'keyDetail.costBreakdown': 'Разбивка на себестойността',
  'keyDetail.supplyPrice': 'Доставна цена',
  'keyDetail.exchangeRate': 'Обменен курс',
  'keyDetail.supplyPriceEur': 'Доставна цена в EUR',
  'keyDetail.shippingAllocated': 'Разпределена доставка',
  'keyDetail.feesAllocated': 'Разпределени такси',
  'keyDetail.total': 'Обща себестойност',
  'keyDetail.noHistory': 'Няма записана история',
  'keyDetail.noSale': 'Този ключ все още не е продаден',
  'keyDetail.changeStatus': 'Промени статус',

  // ---- Shipments ----
  'shipments.title': 'Пратки',
  'shipments.add': 'Нова пратка',
  'shipments.search': 'Търси по номер, доставчик…',
  'shipments.noResults': 'Няма пратки',
  'shipments.emptyDesc': 'Създайте първата пратка',
  'shipment.supplier': 'Доставчик',
  'shipment.date': 'Дата',
  'shipment.tracking': 'Проследяващ номер',
  'shipment.keysCount': 'Брой ключове',
  'shipment.totalCost': 'Обща стойност',
  'shipment.status': 'Статус',
  'shipment.shippingCostUsd': 'Доставка (USD)',
  'shipment.customsFeesEur': 'Мита (EUR)',
  'shipment.otherFeesEur': 'Други такси (EUR)',
  'shipment.exchangeRate': 'Курс USD→EUR',
  'shipment.allocationMethod': 'Метод на разпределение',
  'shipment.notes': 'Бележки',
  'shipment.reallocate': 'Преразпредели разходи',
  'shipment.reallocated': 'Разходите са преразпределени',
  'shipment.addKey': 'Добави ключ',
  'shipment.removeKey': 'Премахни',
  'shipmentForm.newTitle': 'Нова пратка',
  'shipmentForm.editTitle': 'Редактиране на пратка',
  'shipmentForm.created': 'Пратката е създадена',
  'shipmentForm.updated': 'Пратката е обновена',

  // ---- Sales ----
  'sales.title': 'Продажби',
  'sales.add': 'Регистрирай продажба',
  'sales.search': 'Търси по клиент, марка, VIN…',
  'sales.noResults': 'Няма продажби за избраните критерии',
  'sales.emptyDesc': 'Регистрирайте първата продажба',
  'sale.date': 'Дата',
  'sale.customer': 'Клиент',
  'sale.customerContact': 'Контакт',
  'sale.partner': 'Партньор',
  'sale.endCustomer': 'Краен клиент',
  'sale.salePrice': 'Продажна цена',
  'sale.commission': 'Комисион',
  'sale.commissionPercent': 'Комисион %',
  'sale.profit': 'Печалба',
  'sale.carBrand': 'Марка автомобил',
  'sale.carModel': 'Модел автомобил',
  'sale.carYear': 'Година',
  'sale.vinLast6': 'Последни 6 от VIN',
  'sale.key': 'Ключ',
  'sale.programmingJobs': 'Програмиране',
  'sale.jobTool': 'Инструмент',
  'sale.jobType': 'Тип работа',
  'sale.jobDuration': 'Продължителност (мин)',
  'sale.jobSuccess': 'Успешно',
  'sale.addJob': 'Добави работа',
  'sale.totals': 'Общо',
  'saleForm.newTitle': 'Нова продажба',
  'saleForm.editTitle': 'Редактиране на продажба',
  'saleForm.liveProfit': 'Изчислена печалба',
  'saleForm.profitFormula': 'Продажна цена − себестойност − комисион',
  'saleForm.pickKey': 'Изберете ключ',
  'saleForm.noAvailable': 'Няма налични ключове',
  'saleForm.created': 'Продажбата е регистрирана',
  'saleForm.updated': 'Продажбата е обновена',
  'saleDetail.title': 'Продажба',
  'saleDetail.receiptTitle': 'Касова бележка',

  // ---- Partners ----
  'partners.title': 'Партньори',
  'partners.add': 'Нов партньор',
  'partners.noResults': 'Няма партньори',
  'partner.name': 'Име',
  'partner.type': 'Тип',
  'partner.commissionPercent': 'Комисион %',
  'partner.contact': 'Контакт',
  'partner.notes': 'Бележки',
  'partnerForm.newTitle': 'Нов партньор',
  'partnerForm.editTitle': 'Редактиране на партньор',
  'partnerForm.created': 'Партньорът е създаден',
  'partnerForm.updated': 'Партньорът е обновен',
  'partnerForm.deleted': 'Партньорът е изтрит',

  // ---- Suppliers ----
  'suppliers.title': 'Доставчици',
  'suppliers.add': 'Нов доставчик',
  'suppliers.noResults': 'Няма доставчици',
  'supplier.name': 'Име',
  'supplier.country': 'Държава',
  'supplier.contact': 'Контакт',
  'supplier.notes': 'Бележки',
  'supplierForm.newTitle': 'Нов доставчик',
  'supplierForm.editTitle': 'Редактиране на доставчик',
  'supplierForm.created': 'Доставчикът е създаден',
  'supplierForm.updated': 'Доставчикът е обновен',
  'supplierForm.deleted': 'Доставчикът е изтрит',

  // ---- Tools ----
  'tools.title': 'Инструменти',
  'tools.add': 'Нов инструмент',
  'tools.noResults': 'Няма инструменти',
  'tool.name': 'Име',
  'tool.purchaseDate': 'Дата на покупка',
  'tool.purchasePrice': 'Покупна цена',
  'tool.licenseExpiry': 'Изтича лиценз',
  'tool.notes': 'Бележки',
  'toolForm.newTitle': 'Нов инструмент',
  'toolForm.editTitle': 'Редактиране на инструмент',
  'toolForm.created': 'Инструментът е създаден',
  'toolForm.updated': 'Инструментът е обновен',
  'toolForm.deleted': 'Инструментът е изтрит',

  // ---- Reports ----
  'reports.title': 'Справки',
  'reports.subtitle': 'Анализ на финансовите резултати',
  'reports.tabProfitMonth': 'Печалба по месец',
  'reports.tabProfitBrand': 'Печалба по марка',
  'reports.tabToolRoi': 'ROI на инструменти',
  'reports.tabShipmentRoi': 'ROI на пратки',
  'reports.roi': 'Възвръщаемост',
  'reports.totalRevenue': 'Общ приход',
  'reports.totalCost': 'Обща себестойност',
  'reports.jobsCount': 'Брой работи',
  'reports.soldCount': 'Продадени',

  // ---- Settings ----
  'settings.title': 'Настройки',
  'settings.tabGeneral': 'Общи',
  'settings.tabUsers': 'Потребители',
  'settings.tabBackup': 'Архивиране',
  'settings.tabAppearance': 'Изглед',
  'settings.defaultCommission': 'Комисион по подразбиране (%)',
  'settings.defaultExchangeRate': 'Курс USD→EUR по подразбиране',
  'settings.businessName': 'Име на фирма',
  'settings.businessAddress': 'Адрес',
  'settings.businessVat': 'ЕИК / ДДС №',
  'settings.users': 'Потребители',
  'settings.invite': 'Покани потребител',
  'settings.deactivate': 'Деактивирай',
  'settings.activate': 'Активирай',
  'settings.resetPassword': 'Нулирай парола',
  'settings.theme': 'Тема',
  'settings.themeLight': 'Светла',
  'settings.themeDark': 'Тъмна',
  'settings.themeSystem': 'Системна',
  'settings.createBackup': 'Създай архив сега',
  'settings.backupStarted': 'Архивирането е започнато',
  'settings.updated': 'Настройките са запазени',
  'settings.forbiddenTitle': 'Нямате достъп',
  'settings.forbiddenDesc': 'Тази страница е достъпна само за администратори',

  // ---- Command palette ----
  'cmdk.placeholder': 'Търси команда или страница…',
  'cmdk.sectionNav': 'Навигация',
  'cmdk.sectionActions': 'Бързи действия',
  'cmdk.newSale': 'Регистрирай продажба',
  'cmdk.newKey': 'Добави ключ',
  'cmdk.newShipment': 'Нова пратка',
  'cmdk.openHint': 'Отвори',

  // ---- Generic ----
  'common.yes': 'Да',
  'common.no': 'Не',
  'common.required': 'Задължително поле',
  'common.invalid': 'Невалидна стойност',
  'common.noData': 'Няма данни',
  'common.loading': 'Зареждане…',
  'common.error': 'Възникна грешка',
  'common.errorBoundary': 'Нещо се обърка',
  'common.errorBoundaryDesc': 'Възникна неочаквана грешка. Моля, презаредете страницата.',
  'common.notFoundTitle': 'Страницата не е намерена',
  'common.notFoundDesc': 'Адресът, който посетихте, не съществува.',
  'common.goHome': 'Към началото',
  'common.page': 'Страница',
  'common.of': 'от',
  'common.perPage': 'на страница',
  'common.total': 'Общо',
  'common.previous': 'Назад',
  'common.next': 'Напред',
  'common.confirmDelete': 'Потвърждение за изтриване',
  'common.confirmDeleteDesc': 'Сигурни ли сте? Това действие не може да бъде отменено.',
  'common.lightMode': 'Светла тема',
  'common.darkMode': 'Тъмна тема',
  'common.toggleSidebar': 'Превключи менюто',
  'common.commandPalette': 'Палитра с команди',
  'common.welcome': 'Добре дошли',
  'common.sessionExpired': 'Сесията Ви е изтекла. Моля, влезте отново.',
  'common.saved': 'Запазено',
  'common.deleted': 'Изтрито',
  'common.exported': 'Файлът е изтеглен',
  'common.copyLink': 'Копирай връзка',
  'common.copied': 'Копирано',

  // ---- Validation ----
  'validation.email': 'Въведете валиден имейл адрес',
  'validation.required': 'Задължително поле',
  'validation.min': 'Твърде малка стойност',
  'validation.max': 'Твърде голяма стойност',
  'validation.minLength': 'Минимум {n} символа',
  'validation.number': 'Въведете валидно число',
  'validation.positive': 'Стойността трябва да е положителна',
  'validation.year': 'Невалидна година',
  'validation.passwordMin': 'Паролата трябва да е поне 8 символа',

  // ---- Refactored model (keys + sales + warranty) ----
  'app.taglineShort': 'Наличност и продажби на ключове',
  'key.carBrand': 'Марка кола',
  'key.keyModel': 'Модел ключ',
  'key.chipId': 'ID на чипа',
  'key.purchasePrice': 'Покупна цена',
  'inventory.searchShort': 'Търси по ID на чип, модел, марка, клиент…',
  'inventory.filterModel': 'Модел ключ',
  'inventory.allBrands': 'Всички марки',
  'inventory.allModels': 'Всички модели',
  'inventory.allStatuses': 'Всички статуси',
  'inventory.sell': 'Продай',

  // Sell dialog
  'sell.title': 'Продажба на ключ',
  'sell.customer': 'Име на клиент',
  'sell.phone': 'Телефон',
  'sell.date': 'Дата на продажба',
  'sell.price': 'Продажна цена (EUR)',
  'sell.warrantyMonths': 'Гаранция (месеца)',
  'sell.action': 'Продай',
  'sell.success': 'Продажбата е записана',
  'sell.unsell': 'Анулирай продажба',
  'sell.unsellConfirm': 'Анулиране на продажба',
  'sell.unsellConfirmDesc': 'Ключът ще се върне в наличност и данните за клиента ще се изтрият. Продължаване?',
  'sell.unsold': 'Продажбата е анулирана',
  'sell.liveProfit': 'Изчислена печалба',

  // Sale / warranty
  'sale.phone': 'Телефон',
  'sale.warrantyUntil': 'Гаранция до',
  'sale.purchasePrice': 'Покупна цена',

  // Dashboard (refactored)
  'dashboard.soldThisMonth': 'Продадени този месец',
  'dashboard.availableByBrand': 'Наличност по марка',
  'dashboard.noSales': 'Все още няма продажби',

  // Reports (refactored)
  'reports.tabAvailBrand': 'Наличност по марка',
  'reports.tabAvailModel': 'Наличност по модел',
  'reports.count': 'Брой',
  'reports.value': 'Стойност',
  'reports.profit': 'Печалба',
  'reports.brands': 'Марки',

  // Key detail (refactored)
  'keyDetail.customerInfo': 'Данни за продажбата',
  'keyDetail.warranty': 'Гаранция',
  'keyDetail.printWarranty': 'Печат на гаранция',
  'keyDetail.warrantyCard': 'Гаранционна карта',
  'keyDetail.notSold': 'Ключът е наличен (не е продаден)',

  // Settings (refactored)
  'settings.defaultWarranty': 'Гаранция по подразбиране (месеца)',
  'settings.businessPhone': 'Телефон на фирма',

  // Bulk add (key form)
  'keyForm.chipIdSingle': 'ID на чипа',
  'keyForm.chipIdsMulti': 'ID на чиповете (по едно на ред)',
  'keyForm.chipIdsHint': 'Въведи по едно ID на ред — за всяко се създава отделен ключ.',
  'keyForm.countLabel': 'Брой ключове',
  'keyForm.bulkCreated': 'Добавени са {n} ключа',

  // New sale (multi-key) dialog
  'newSale.title': 'Нова продажба',
  'newSale.button': 'Нова продажба',
  'newSale.pickKeys': 'Избери ключове',
  'newSale.searchKeys': 'Търси налични по ID, марка, модел…',
  'newSale.selected': 'Избрани ключове',
  'newSale.noneSelected': 'Все още няма избрани ключове',
  'newSale.pricePerKey': 'Цена',
  'newSale.total': 'Общо',
  'newSale.success': 'Продажбата е записана ({n} ключа)',
  'newSale.needKeyAndCustomer': 'Избери поне един ключ и въведи клиент',

  // Report filters + low stock
  'reports.filterBrand': 'Марка',
  'reports.filterModel': 'Модел',
  'reports.allBrands': 'Всички марки',
  'reports.allModels': 'Всички модели',
  'reports.period': 'Период',
  'reports.months6': 'Последни 6 месеца',
  'reports.months12': 'Последни 12 месеца',
  'reports.months24': 'Последни 24 месеца',
  'dashboard.lowStock': 'Свършващи модели',
  'dashboard.lowStockHint': 'Модели с 1 или 0 налични — за презареждане',
  'dashboard.lowStockNone': 'Всички модели имат достатъчна наличност',
  'dashboard.available': 'налични',

  // Clone + warranty
  'keyDetail.cloneAdd': 'Добави още като този',
  'keyForm.cloneTitle': 'Нов ключ (по образец)',
  'sale.warrantyActive': 'активна',
  'sale.warrantyExpiring': 'изтича скоро',
  'sale.warrantyExpired': 'изтекла',

  // Compatibility (key model <-> car)
  'nav.compat': 'Съвместимост',
  'compat.title': 'Съвместимост',
  'compat.findTitle': 'Намери ключ за кола',
  'compat.carBrand': 'Марка кола',
  'compat.carModel': 'Модел кола',
  'compat.year': 'Година',
  'compat.find': 'Търси',
  'compat.noMatches': 'Няма съвпадения за тази кола',
  'compat.searchPrompt': 'Въведи марка/модел/година, за да видиш кои ключове стават',
  'compat.inStock': 'в наличност',
  'compat.outOfStock': 'няма наличност',
  'compat.verified': 'проверено',
  'compat.toVerify': 'за проверка',
  'compat.manageTitle': 'Записи за съвместимост',
  'compat.add': 'Добави запис',
  'compat.keyModel': 'Модел ключ',
  'compat.years': 'Години',
  'compat.onlyUnverified': 'Само „за проверка"',
  'compat.search': 'Търси по модел ключ, марка, кола…',
  'compat.markVerified': 'Потвърди',
  'compat.import': 'Импорт от CSV',
  'compat.importTitle': 'Импорт на съвместимост',
  'compat.importHint': 'По един ред: модел ключ, марка кола, модел кола, година от, година до',
  'compat.imported': 'Импортирани са {n} записа',
  'compat.created': 'Записът е добавен',
  'compat.updated': 'Записът е обновен',
  'compat.deleted': 'Записът е изтрит',
  'compat.source': 'Източник',
  'compat.note': 'Бележка',
  'compat.noData': 'Все още няма записи за съвместимост',

  // Chip fields
  'key.chipType': 'Тип чип',
  'key.chipSubtype': 'Подтип',
  'key.frequency': 'Честота',

  // Labels / printing
  'nav.labels': 'Етикети',
  'labels.print': 'Печат на етикети',
  'labels.title': 'Печат на етикети',
  'labels.selectedCount': 'Избрани ключове',
  'labels.startRow': 'Започни от ред',
  'labels.startCol': 'Започни от колона',
  'labels.printBtn': 'Печат',
  'labels.preview': 'Преглед',
  'labels.noKeys': 'Няма избрани ключове за печат',
  'labels.backToInventory': 'Към наличност',
  'labels.printHint': 'Жълтите клетки се пропускат (вече използвани). Провери подравняването с тестов печат.',
  'labels.settingsTitle': 'Етикети (хартия)',
  'labels.cols': 'Колони',
  'labels.rows': 'Редове',
  'labels.labelWidth': 'Ширина на етикет (mm)',
  'labels.labelHeight': 'Височина на етикет (mm)',
  'labels.marginTop': 'Горно поле (mm)',
  'labels.marginLeft': 'Ляво поле (mm)',
  'labels.gapX': 'Хоризонтално разстояние (mm)',
  'labels.gapY': 'Вертикално разстояние (mm)',
  'labels.testPrint': 'Тестов печат (празна решетка)',
  'labels.tabLabels': 'Етикети',
  'labels.contentPadding': 'Отстъп на съдържанието отстрани (mm)',

  // QR scanner
  'scan.title': 'Сканиране на QR код',
  'scan.hint': 'Насочи камерата към QR кода на етикета',
  'scan.button': 'Сканирай',
  'scan.cameraError': 'Няма достъп до камера. Разреши достъпа в браузъра и опитай пак.',
  'scan.added': 'Добавен: {name}',
  'scan.notFound': 'Няма наличен ключ с този код',
  'scan.alreadySold': 'Този ключ вече е продаден',
  'scan.alreadyAdded': 'Този ключ вече е добавен',
  'scan.found': 'Намерен: {name}',

  // Print-after-add + single label + frequency
  'keyForm.printAfter': 'След добавяне → печат на етикети',
  'keyForm.freqHint': 'само число (MHz се добавя автоматично)',
  'keyDetail.printLabel': 'Печат на етикет',

  // Label-printed tracking
  'inventory.filterLabel': 'Етикет',
  'inventory.labelAll': 'Етикет: всички',
  'inventory.labelPrinted': 'С етикет',
  'inventory.labelUnprinted': 'Без етикет',
  'key.labelPrinted': 'етикет',
  'key.printedYes': 'отпечатан',
  'key.printedNo': 'без етикет',
  'labels.marked': 'Отбелязани като отпечатани ({n})',
  'labels.undo': 'Отмени',
  'keyDetail.labelStatus': 'Етикет',
  'keyDetail.markPrinted': 'Отбележи като отпечатан',
  'keyDetail.markUnprinted': 'Отбележи като неотпечатан',

  // Box labels (storage boxes)
  'boxLabels.title': 'Етикети за кутии',
  'boxLabels.nav': 'Етикети за кутии',
  'boxLabels.main': 'Основен текст (марка)',
  'boxLabels.sub': 'Втори ред (по избор)',
  'boxLabels.copies': 'Брой',
  'boxLabels.add': 'Добави',
  'boxLabels.quickBrands': 'Бързо от наличните марки',
  'boxLabels.list': 'Етикети за печат',
  'boxLabels.empty': 'Добави поне един етикет',
  'boxLabels.mainRequired': 'Въведи основен текст',
  'boxLabels.placeholderMain': 'напр. Jeep',
  'boxLabels.placeholderSub': 'напр. M3N-40821302',

  // Resellers / commission
  'reseller.label': 'Резелър',
  'reseller.none': 'Без резелър (директна продажба)',
  'reseller.commissionPercent': 'Комисиона %',
  'reseller.commissionEur': 'Комисиона',
  'sell.afterCommission': 'Печалба (след комисиона)',
  'settings.tabResellers': 'Резелъри',
  'resellers.add': 'Нов резелър',
  'resellers.name': 'Име',
  'resellers.defaultPercent': 'Комисиона по подразбиране (%)',
  'resellers.contact': 'Контакт',
  'resellers.notes': 'Бележки',
  'resellers.created': 'Резелърът е добавен',
  'resellers.updated': 'Резелърът е обновен',
  'resellers.deleted': 'Резелърът е изтрит',
  'resellers.none': 'Все още няма резелъри',
  'reports.tabCommission': 'Комисиони по резелър',
  'reports.commission': 'Комисиона',
  'reports.totalSales': 'Оборот',

  // Edit sale
  'sell.editTitle': 'Редактиране на продажба',
  'sell.updated': 'Продажбата е обновена',
  'sell.editAction': 'Запази',
  'keyDetail.editSale': 'Редактирай продажба',
};

export type I18nKey = keyof typeof dict;

/**
 * Lookup a Bulgarian string by key. Accepts both known `I18nKey`s and raw
 * strings (for dynamic lookups like `condition.${value}`). Missing keys fall
 * back to the key itself — safe but visible during development.
 */
export function t(key: I18nKey | string, params?: Record<string, string | number>): string {
  const raw = (dict as Record<string, string>)[key] ?? key;
  if (!params) return raw;
  return Object.entries(params).reduce(
    (acc, [k, v]) => acc.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v)),
    raw,
  );
}

/** Pluralisation helper — simple 1 / other rule sufficient for Bulgarian UI here. */
export function tn(n: number, one: I18nKey, many: I18nKey): string {
  return n === 1 ? t(one) : t(many);
}
